import * as React from "react";

const DynamicComponent = (props: any) => {
  const { component, ...restProps } = props;
  const Component = component;

  return <Component {...restProps}></Component>;
};

export default DynamicComponent;
